import { AllocationValueType, TransferFeeDeductType } from "@/enums/enums";
import { GetTransactionSummary } from "@/helper/transactionItemHelper";
import { AllocationItemListModel } from "@/model/classification";

export function ConvertToAISuggestionAccountByContact(aiSuggestionTransactionRaw: any) {
  const aiSuggestionTransaction = {
    isActive: false,
    expenseTypeId: 0,
    transactionId: 0,
    chartOfAccountList: [] as any[],
    suggestionAccountMongoId: "",
  };
  if (aiSuggestionTransactionRaw && aiSuggestionTransactionRaw.transactionId > 0) {
    aiSuggestionTransaction.isActive = true;
    aiSuggestionTransaction.transactionId = aiSuggestionTransactionRaw.transactionId;
    aiSuggestionTransaction.expenseTypeId = aiSuggestionTransactionRaw.expenseTypeId;
  } else if (
    aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId._id &&
    aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId.chartOfAccounts &&
    aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId.chartOfAccounts.length > 0
  ) {
    aiSuggestionTransaction.isActive = true;
    aiSuggestionTransaction.suggestionAccountMongoId = aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId._id;
    for (const chartOfAccount of aiSuggestionTransactionRaw.recommendChartOfAccountByTaxId.chartOfAccounts) {
      aiSuggestionTransaction.chartOfAccountList.push({ accountId: chartOfAccount.accountId });
    }
  }
  return aiSuggestionTransaction;
}

function GetCreateAllocationTransaction(allocationTransacionRawList: any) {
  const allocationTransactionList = [];
  if (allocationTransacionRawList && allocationTransacionRawList.length > 0) {
    for (const allocationTransacionRaw of allocationTransacionRawList) {
      if (
        allocationTransacionRaw.classificationId &&
        allocationTransacionRaw.classificationItemList &&
        allocationTransacionRaw.classificationItemList.length > 0
      ) {
        const allocationTransaction = {
          allocationId: allocationTransacionRaw.classificationId,
          allocationItemList: Array<AllocationItemListModel>(),
        };
        for (const allocationItemRaw of allocationTransacionRaw.classificationItemList) {
          if (allocationItemRaw.id > 0) {
            allocationTransaction.allocationItemList.push({
              allocationItemId: allocationItemRaw.id,
              allocationValue: 100,
              allocationValueType: AllocationValueType.Percent,
              allocationPercent: 100,
            });
          }
        }
        if (allocationTransaction.allocationId > 0 && allocationTransaction.allocationItemList.length > 0) {
          allocationTransactionList.push(allocationTransaction);
        }
      }
    }
  }
  return allocationTransactionList;
}

function ConvertToTransactionDetail(_transaction: any) {
  const transactionDetailTemplate = {
    referenceName: _transaction.referenceName,
    id: _transaction.id,
    number: _transaction.number,
    uuid: _transaction.uuid,
    date: _transaction.date,
    dueDate: _transaction.dueDate ? _transaction.dueDate : null,
    actionDate: _transaction.actionDate,
    isVat: _transaction.isVat,
    isDeleted: _transaction.isDeleted,
    discount: _transaction.discount,
    discountType: _transaction.discountType,
    remark: _transaction.remark,
    transactionStatus: _transaction.transactionStatus,
    contactId: _transaction.contactId,
    transactionType: _transaction.transactionType,
    financeType: _transaction.financeType,
    expenseType: _transaction.expenseType,
    taxStatus: _transaction.taxStatus,
    userId: _transaction.userId,
    lockStatusId: _transaction.lockStatusId,
    transactionSummary: {
      preVatTotal: _transaction.transactionSummary.preVatTotal,
      zeroVatTotal: _transaction.transactionSummary.zeroVatTotal,
      vatExemptedTotal: _transaction.transactionSummary.vatExemptedTotal,
      taxExclusiveTotal: _transaction.transactionSummary.taxExclusiveTotal,
      vatTotal: _transaction.transactionSummary.vatTotal,
      subTotal: _transaction.transactionSummary.subTotal,
      netAmount: _transaction.transactionSummary.netAmount,
      subTotalForCalculateWht: _transaction.transactionSummary.subTotalForCalculateWht,
      whtTotal: _transaction.transactionSummary.whtTotal,
      remainPaymentNetAmount: _transaction.transactionSummary.remainPaymentNetAmount,
      remainWhtPaymentNetAmount: _transaction.transactionSummary.remainWhtPaymentNetAmount,
      isAllNoneOrNotSpecifyWht: _transaction.transactionSummary.isAllNoneOrNotSpecifyWht,
      isServiceOnly: _transaction.transactionSummary.isServiceOnly,
      sameProductVatType: _transaction.transactionSummary.sameProductVatType,
    },
    transactionCurrency: {
      fromCurrencyUid: _transaction.transactionCurrency.fromCurrencyUid,
      toCurrencyUid: _transaction.transactionCurrency.toCurrencyUid,
      fromCurrencyCode: _transaction.transactionCurrency.fromCurrencyCode,
      toCurrencyCode: _transaction.transactionCurrency.toCurrencyCode,
      fromCurrencyCountryName: _transaction.transactionCurrency.fromCurrencyCountryName,
      toCurrencyCountryName: _transaction.transactionCurrency.toCurrencyCountryName,
      currencyExchangeRates: _transaction.transactionCurrency.currencyExchangeRates,
      currencyRatio: _transaction.transactionCurrency.currencyRatio,
      currencyPreVatTotal: _transaction.transactionCurrency.currencyPreVatTotal,
      currencyZeroVatTotal: _transaction.transactionCurrency.currencyZeroVatTotal,
      currencyVatExemptedTotal: _transaction.transactionCurrency.currencyVatExemptedTotal,
      currencyTaxExclusiveTotal: _transaction.transactionCurrency.currencyTaxExclusiveTotal,
      currencyVatTotal: _transaction.transactionCurrency.currencyVatTotal,
      currencySubTotal: _transaction.transactionCurrency.currencySubTotal,
      currencyNetAmount: _transaction.transactionCurrency.currencyNetAmount,
      currencySubTotalForCalculateWht: _transaction.transactionCurrency.currencySubTotalForCalculateWht,
      currencyWhtTotal: _transaction.transactionCurrency.currencyWhtTotal,
    },
    transactionItems: [] as any[],
  };
  if (_transaction.transactionItemList && _transaction.transactionItemList.length > 0) {
    _transaction.transactionItemList.forEach((transactionItems: any) => {
      const transactionItemsTemplate = {
        id: transactionItems.id,
        productTemplateId: transactionItems.productTemplateId,
        description: transactionItems.description,
        price: transactionItems.price,
        amount: transactionItems.amount,
        discount: transactionItems.discount,
        vatType: transactionItems.vatType,
        discountType: transactionItems.discountType,
        netAmount: transactionItems.netAmount,
        productTemplateCode: transactionItems.code,
        stockactivityId: transactionItems.stockactivityId,
        accountId: transactionItems.accountId,
        accountCode: transactionItems.accountCode,
        accountName: transactionItems.accountName,
        accountNameEng: transactionItems.accountNameEng,
        productTemplateUuid: transactionItems.productTemplateUuid,
        uuid: transactionItems.uuid,
        isDescriptionOnly: transactionItems.isDescriptionOnly,
        accountRefId: transactionItems.accountRefId,
        accountRefTypeId: transactionItems.accountRefTypeId,
        refTransactionProductId: transactionItems.refTransactionProductId,
        refStockActivityId: transactionItems.refStockActivityId,
        creditNoteRefTransactionId: transactionItems.creditNoteRefTransactionId,
        refTransactionTypeId: transactionItems.refTransactionTypeId,
        pp30TransactionProductId: transactionItems.pp30TransactionProductId,
        isPP30Checked: transactionItems.isPP30Checked,
        isPP30Created: transactionItems.isPP30Created,
        billedAmount: transactionItems.billedAmount,
        vatAmount: transactionItems.vatAmount,
        fixAssetTemplateId: transactionItems.fixAssetTemplateId,
        whtPercent: transactionItems.whtPercent,
        whtAmount: transactionItems.whtAmount,
        whtAmountType: transactionItems.whtAmountType,
        taxIncomeTypeId: transactionItems.taxIncomeTypeId,
        subTotal: transactionItems.subTotal,
        sequenceNumber: transactionItems.sequenceNumber,
        unitId: transactionItems.unitId,
        unitName: "",
      };

      transactionDetailTemplate.transactionItems.push(transactionItemsTemplate);
    });
  }
  return transactionDetailTemplate;
}

function ConvertToReceivedIssuedTaxInvoice(receivedIssuedTaxInvoiceRawList: any) {
  const receivedIssuedTaxInvoiceList = [];
  if (receivedIssuedTaxInvoiceRawList && receivedIssuedTaxInvoiceRawList.length > 0) {
    for (const receivedIssuedTaxInvoiceRaw of receivedIssuedTaxInvoiceRawList) {
      const receivedIssuedTaxInvoice = {
        referencedJournalList: [] as any[],
        id: receivedIssuedTaxInvoiceRaw.id,
        receivedTaxInvoiceNumber: receivedIssuedTaxInvoiceRaw.receivedTaxInvoiceNumber,
        receivedTaxInvoiceDate: receivedIssuedTaxInvoiceRaw.receivedTaxInvoiceDate,
        preVatTotal: receivedIssuedTaxInvoiceRaw.preVatTotal,
        vatTotal: receivedIssuedTaxInvoiceRaw.vatTotal,
        netAmount: receivedIssuedTaxInvoiceRaw.netAmount,
        etaxInvoiceId: receivedIssuedTaxInvoiceRaw.etaxInvoiceId,
        taxInvoiceId: receivedIssuedTaxInvoiceRaw.taxInvoiceId,
        referenceTransactionType: receivedIssuedTaxInvoiceRaw.referenceTransactionType,
        referenceTransactionId: receivedIssuedTaxInvoiceRaw.referenceTransactionId,
        referencePaymentGroupId: receivedIssuedTaxInvoiceRaw.referencePaymentGroupId,
      };
      if (
        receivedIssuedTaxInvoiceRaw.referencedJournalList &&
        receivedIssuedTaxInvoiceRaw.referencedJournalList.length > 0
      ) {
        for (const referenceJournal of receivedIssuedTaxInvoiceRaw.referencedJournalList) {
          receivedIssuedTaxInvoice.referencedJournalList.push({
            journalId: referenceJournal.journalId,
            journalNumber: referenceJournal.journalNumber,
            isDeleted: referenceJournal.isDeleted,
            journalLockStatus: referenceJournal.journalLockStatus,
          });
        }
      }
      receivedIssuedTaxInvoiceList.push(receivedIssuedTaxInvoice);
    }
    return receivedIssuedTaxInvoiceList;
  }
}

export function ConvertToInvoiceDetail(_transaction: any) {
  const transaction: any = ConvertToTransactionDetail(_transaction);
  transaction.referenceId = _transaction.referenceId;
  transaction.referenceType = _transaction.referenceType;
  transaction.isCreatedTaxInvoice = _transaction.isCreatedTaxInvoice;
  transaction.billedCount = _transaction.billedCount;
  transaction.billedTotal = _transaction.billedTotal;
  transaction.billedTotalAwaitPaidPayment = _transaction.billedTotalAwaitPaidPayment;
  transaction.billedWhtTotal = _transaction.billedWhtTotal;
  transaction.creditNoteCount = _transaction.creditNoteCount;
  transaction.creditNoteTotal = _transaction.creditNoteTotal;
  transaction.creditNoteWhtTotal = _transaction.creditNoteWhtTotal;
  transaction.paymentCount = _transaction.paymentCount;
  transaction.paidTotal = _transaction.paidTotal;
  transaction.isHavePayment = _transaction.paymentCount > 0;
  transaction.receivedTaxInvoiceList = ConvertToReceivedIssuedTaxInvoice(_transaction.receivedTaxInvoiceList);
  return transaction;
}

export function ConvertBookmarkDetailToTransactionDetail(bookmarkModel: any) {
  const bookmarkTemplate = {
    id: bookmarkModel.id,
    name: bookmarkModel.name,
    isRememberContact: bookmarkModel.isRememberContact,
    isRememberAmountAndPrice: bookmarkModel.isRememberAmountAndPrice,
    description: bookmarkModel.description,
    transactionType: bookmarkModel.transactionType,
    financeType: bookmarkModel.financeType,
    transactionTemplateId: bookmarkModel.transactionTemplateDetailModel.id,
    contactId: bookmarkModel.transactionTemplateDetailModel.contactId,
    expenseType: bookmarkModel.transactionTemplateDetailModel.expenseType,
    taxStatus: bookmarkModel.transactionTemplateDetailModel.taxStatus,
    status: bookmarkModel.transactionTemplateDetailModel.status,
    remark: bookmarkModel.transactionTemplateDetailModel.remark,
    discount: bookmarkModel.transactionTemplateDetailModel.discount,
    discountType: bookmarkModel.transactionTemplateDetailModel.discountType,
    isAllNoneOrNotSpecifyWht: bookmarkModel.transactionTemplateDetailModel.isAllNoneOrNotSpecifyWht,
    isServiceOnly: bookmarkModel.transactionTemplateDetailModel.isServiceOnly,
    netAmount: bookmarkModel.transactionTemplateDetailModel.netAmount,
    subTotal: bookmarkModel.transactionTemplateDetailModel.subTotal,
    preVatTotal: bookmarkModel.transactionTemplateDetailModel.preVatTotal,
    zeroVatTotal: bookmarkModel.transactionTemplateDetailModel.zeroVatTotal,
    vatTotal: bookmarkModel.transactionTemplateDetailModel.vatTotal,
    vatExemtedTotal: bookmarkModel.transactionTemplateDetailModel.vatExemtedTotal,
    subTotalForCalculateWht: bookmarkModel.transactionTemplateDetailModel.subTotalForCalculateWht,
    whtTotal: bookmarkModel.transactionTemplateDetailModel.whtTotal,
    sameProductVatTypeId: bookmarkModel.transactionTemplateDetailModel.sameProductVatTypeId,
    currencyExchangeRates: bookmarkModel.transactionTemplateDetailModel.currencyExchangeRates,
    fromCurrencyUid: bookmarkModel.transactionTemplateDetailModel.fromCurrencyUid,
    toCurrencyUid: bookmarkModel.transactionTemplateDetailModel.toCurrencyUid,
    currencyRatio: bookmarkModel.transactionTemplateDetailModel.currencyRatio,
    currencyNetAmount: bookmarkModel.transactionTemplateDetailModel.currencyNetAmount,
    currencyPreVatTotal: bookmarkModel.transactionTemplateDetailModel.currencyPreVatTotal,
    currencyZeroVatTotal: bookmarkModel.transactionTemplateDetailModel.currencyZeroVatTotal,
    currencyVatExemptedTotal: bookmarkModel.transactionTemplateDetailModel.currencyVatExemptedTotal,
    currencySubTotalForCalculateWht: bookmarkModel.transactionTemplateDetailModel.currencySubTotalForCalculateWht,
    currencyVatTotal: bookmarkModel.transactionTemplateDetailModel.currencyVatTotal,
    currencyWhtTotal: bookmarkModel.transactionTemplateDetailModel.currencyWhtTotal,
    isCreateTaxInvoice: bookmarkModel.transactionTemplateDetailModel.isCreateTaxInvoice,
    transactionItems: [] as any[],
  };
  if (
    bookmarkModel.transactionTemplateProductDetailModel &&
    bookmarkModel.transactionTemplateProductDetailModel.length > 0
  ) {
    bookmarkModel.transactionTemplateProductDetailModel.forEach((items: any) => {
      const bookmarkItemsTemplate = {
        accountCode: items.accountCode,
        productTemplateCode: items.productTemplateCode,
        sequenceNumber: items.sequenceNumber,
        description: items.description,
        isDescriptionOnly: items.isDescriptionOnly,
        productTemplateId: items.productTemplateId,
        accountId: items.accountId,
        price: items.price,
        amount: items.amount,
        discount: items.discount,
        discountType: items.discountType,
        vatType: items.vatTypeId,
        netAmount: items.netAmount,
        whtAmount: items.whtAmount,
        whtAmountType: items.whtAmountTypeId,
        typeId: items.typeId,
      };
      bookmarkTemplate.transactionItems.push(bookmarkItemsTemplate);
    });
  }

  return bookmarkTemplate;
}

export const ConvertPaymentWhtForCreateModel = (whtPaymentRawData: any) => {
  const wht = {
    whtAmount: 0,
    whtAmountType: 0,
    pndType: 0,
    whtDeductType: 0,
  };
  if (whtPaymentRawData) {
    wht.whtAmount = whtPaymentRawData.whtAmount;
    wht.whtAmountType = whtPaymentRawData.whtAmountTypeId;
    wht.pndType = whtPaymentRawData.pndTypeId;
    wht.whtDeductType = whtPaymentRawData.whtDeductType;
  }
  return wht;
};

export const ConvertPaymentChequeCreateForCreateModel = (isCheque: any, chequeRawData: any) => {
  const cheque = {
    chequeNumber: "",
    branchNumber: "",
    accountNumber: "",
    chequeDate: new Date(),
    chequeBankId: 0,
  };
  if (isCheque && chequeRawData) {
    cheque.chequeNumber = chequeRawData.chequeNumber;
    cheque.branchNumber = chequeRawData.branchNumber;
    cheque.accountNumber = chequeRawData.accountNumber;
    cheque.chequeDate = chequeRawData.chequeDate;
    cheque.chequeBankId = chequeRawData.chequeBankId;
  }
  return cheque;
};

export const ConvertPaymentTransactionChartAccountForCreateModel = (paymentTransactionChartAccountRawData: any) => {
  const paymentTransactionChartAccount = {
    accountId: 0,
    remark: "",
    paymentAmount: 0,
  };
  if (paymentTransactionChartAccountRawData && paymentTransactionChartAccountRawData.accountId > 0) {
    paymentTransactionChartAccount.accountId = paymentTransactionChartAccountRawData.accountId;
    paymentTransactionChartAccount.remark = paymentTransactionChartAccountRawData.remark;
    paymentTransactionChartAccount.paymentAmount =
      (paymentTransactionChartAccountRawData.adjustValue == TransferFeeDeductType.WithDrawalAccount ? -1 : 1) *
      paymentTransactionChartAccountRawData.paymentAmount.ToNumber();
  }
  return paymentTransactionChartAccount;
};

export const ConvertPaymentTransactionBankAccountForCreateModel = (paymentTransactionBankAccountRawData: any) => {
  const paymentTransactionBankAccount = {
    remark: "",
    paymentAmount: 0,
    isCheque: false,
    cheque: {},
    bankAccountId: 0,
  };
  if (
    paymentTransactionBankAccountRawData &&
    (paymentTransactionBankAccountRawData.bankAccountId > 0 || paymentTransactionBankAccountRawData.isCheque)
  ) {
    paymentTransactionBankAccount.remark = paymentTransactionBankAccountRawData.remark;
    paymentTransactionBankAccount.paymentAmount = paymentTransactionBankAccountRawData.paymentAmount;
    paymentTransactionBankAccount.isCheque = paymentTransactionBankAccountRawData.isCheque;
    paymentTransactionBankAccount.cheque = ConvertPaymentChequeCreateForCreateModel(
      paymentTransactionBankAccountRawData.isCheque,
      paymentTransactionBankAccountRawData.cheque
    );
    if (paymentTransactionBankAccountRawData.bankAccountId > 0) {
      paymentTransactionBankAccount.bankAccountId = paymentTransactionBankAccountRawData.bankAccountId;
    }
  }
  return paymentTransactionBankAccount;
};

export const ConvertPaymentTransactionDocumentForCreateModel = (paymentTransactionDocumentRawData: any) => {
  const paymentTransactionDocument = {
    referenceTransactionId: 0,
    referenceTransactionType: 0,
    remark: "",
    paymentAmount: 0,
  };
  if (paymentTransactionDocumentRawData && paymentTransactionDocumentRawData.transactionId > 0) {
    paymentTransactionDocument.referenceTransactionId = paymentTransactionDocumentRawData.transactionId;
    paymentTransactionDocument.referenceTransactionType = paymentTransactionDocumentRawData.transactionType.value;
    paymentTransactionDocument.remark = paymentTransactionDocumentRawData.remark;
    paymentTransactionDocument.paymentAmount = paymentTransactionDocumentRawData.paymentAmount;
  }
  return paymentTransactionDocument;
};

export const ConvertPaymentGroupForCreateModel = (paymentRaw: any) => {
  const payment = {
    date: null,
    paymentTransactionBankAccountList: [] as any[],
    paymentTransactionChartOfAccountList: [] as any[],
    paymentTransactionReferenceList: [] as any[],
    wht: ConvertPaymentWhtForCreateModel(null),
  };

  if (paymentRaw.paymentGroupList) {
    for (const paymentGroup of paymentRaw.paymentGroupList) {
      payment.date = paymentGroup.paymentGroupDate;
      if (paymentGroup.isPaymentActive) {
        payment.wht = ConvertPaymentWhtForCreateModel(paymentGroup.whtPayment);

        if (
          paymentGroup.paymentTransactionBankAccountList &&
          paymentGroup.paymentTransactionBankAccountList.length > 0
        ) {
          for (const paymentTransactionBankAccountItem of paymentGroup.paymentTransactionBankAccountList) {
            const paymentTransactionBankAccount = ConvertPaymentTransactionBankAccountForCreateModel(
              paymentTransactionBankAccountItem
            );
            payment.paymentTransactionBankAccountList.push(paymentTransactionBankAccount);
          }
        }

        if (paymentGroup.paymentTransactionChartAccountActived && paymentGroup.paymentTransactionChartOfAccountList) {
          for (const paymentTransactionChartAccountItem of paymentGroup.paymentTransactionChartOfAccountList) {
            const paymentTransactionChartAccount = ConvertPaymentTransactionChartAccountForCreateModel(
              paymentTransactionChartAccountItem
            );
            payment.paymentTransactionChartOfAccountList.push(paymentTransactionChartAccount);
          }
        }

        if (paymentGroup.paymentTransactionDocumentActived && paymentGroup.paymentTransactionDocumentList) {
          for (const paymentTransactionDocumentItem of paymentGroup.paymentTransactionDocumentList) {
            const paymentTransactionDocument = ConvertPaymentTransactionDocumentForCreateModel(
              paymentTransactionDocumentItem
            );
            payment.paymentTransactionReferenceList.push(paymentTransactionDocument);
          }
        }
      }
    }
  }

  return payment;
};

function GetCreateTransactionBase(transaction: any) {
  const summary = GetTransactionSummary(transaction);
  const transactionBase = {
    number: transaction.number.value,
    date: transaction.date.value,
    dueDate: transaction.dueDate.value,
    remark: transaction.remark.text,
    contactId: transaction.contact.id,
    referenceName: transaction.reference.referenceName,
    taxStatus: transaction.taxStatus.value,
    status: 0,
    financeTypeId: transaction.financeType,
    currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
    currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
    fromCurrencyUId: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
    toCurrencyUId: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
    fromCurrencyDepositVatTotal: "0.00",
    fromCurrencyDepositPreVatTotal: "0.00",
    fromCurrencyDepositZeroVatTotal: "0.00",
    fromCurrencyDepositVatExemptedTotal: "0.00",
    toCurrencyDepositVatTotal: "0.00",
    toCurrencyDepositPreVatTotal: "0.00",
    toCurrencyDepositZeroVatTotal: "0.00",
    toCurrencyDepositVatExemptedTotal: "0.00",
    fromCurrency: {
      discount: transaction.transactionSummary.discount.ToNumber(),
      whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
      netTotal: transaction.transactionSummary.netAmount.ToNumber(),
      vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
      preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
      zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
      vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
      subTotalForcalculateWHT: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
    },
    toCurrency: {
      discount: transaction.transactionCurrencySummary.discount.ToNumber(),
      whtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
      netTotal: transaction.transactionCurrencySummary.netAmount.ToNumber(),
      vatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
      preVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
      zeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
      vatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
      subTotalForcalculateWHT: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
    },
    paymentGroup: ConvertPaymentGroupForCreateModel(transaction.payment),
    discountType: transaction.transactionDiscount.discountType,
    fileList: transaction.fileList,
    tagList: transaction.tagList,
    allocationTransactionList: GetCreateAllocationTransaction(transaction.classificationTransactionList),
    transactionItemList: [] as any[],
    receivedTaxInvoiceList: [] as any[],
    referenceTransactionId: transaction.reference.referenceId,
    referenceTransactionType: transaction.reference.referenceTypeId,
    isCreatedTaxInvoice: transaction.issueTaxInvoice.value,
    isTaxDocument: transaction.issueTaxInvoice.value ? true : transaction.issueTaxDocument.value,
    referenceDepositList: [] as any[],
  };

  return transactionBase;
}

function ConvertToReferenceDepositListCreate(referenceDepositRawList: any) {
  const referenceDepositList = [];
  if (referenceDepositRawList && referenceDepositRawList.length > 0) {
    for (const referenceDepositRaw of referenceDepositRawList) {
      referenceDepositList.push({
        depositId: referenceDepositRaw.depositId,
        fromCurrencyWHTTotal: referenceDepositRaw.fromCurrencyWHTTotal,
        fromCurrencyNetTotal: referenceDepositRaw.fromCurrencyNetTotal,
        fromCurrencyVatTotal: referenceDepositRaw.fromCurrencyVatTotal,
        fromCurrencyPreVatTotal: referenceDepositRaw.fromCurrencyPreVatTotal,
        fromCurrencyZeroVatTotal: referenceDepositRaw.fromCurrencyZeroVatTotal,
        fromCurrencyVatExemptedTotal: referenceDepositRaw.fromCurrencyVatExemptedTotal,
        fromCurrencySubTotalForcalculateWHT: referenceDepositRaw.fromCurrencySubTotalForcalculateWHT,
        toCurrencyWHTTotal: referenceDepositRaw.toCurrencyWHTTotal,
        toCurrencyNetTotal: referenceDepositRaw.toCurrencyNetTotal,
        toCurrencyVatTotal: referenceDepositRaw.toCurrencyVatTotal,
        toCurrencyPreVatTotal: referenceDepositRaw.toCurrencyPreVatTotal,
        toCurrencyZeroVatTotal: referenceDepositRaw.toCurrencyZeroVatTotal,
        toCurrencyVatExemptedTotal: referenceDepositRaw.toCurrencyVatExemptedTotal,
        toCurrencySubTotalForcalculateWHT: referenceDepositRaw.toCurrencySubTotalForcalculateWHT,
      });
    }
  }
  return referenceDepositList;
}

function GetCreateTransactionItemBase(transaction: any, transactionItem: any) {
  const transactionItemBase = {
    transactionId: 0,
    description: transactionItem.description.text,
    vatType: transactionItem.vatTypeId.value,
    discountType: transactionItem.discount.discountTypeId,
    quantity: transactionItem.amount.value.ToNumber(),
    isDescriptionOnly: transactionItem.isDescriptionOnly,
    whtAmountType: transactionItem.itemWht.whtAmountType,
    productTemplateId: transactionItem.productTemplate.id,
    productTemplateCode: transactionItem.productTemplate.code,
    referenceQuotationItemId: transactionItem.referenceQuotationItemId,
    accountId: transactionItem.account.id,
    accountCode: transactionItem.account.code,
    fromCurrencyPrice: transactionItem.fromCurrencyPrice.ToNumber(),
    fromCurrencyDiscount: transactionItem.fromCurrencyDiscount.ToNumber(),
    fromCurrencyWHTTotal: transactionItem.fromCurrencyWHTTotal.ToNumber(),
    fromCurrencyNetTotal: transactionItem.fromCurrencyNetTotal.ToNumber(),
    fromCurrencyVatTotal: transactionItem.fromCurrencyVatTotal.ToNumber(),
    fromCurrencyPreVatTotal: transactionItem.fromCurrencyPreVatTotal.ToNumber(),
    fromCurrencyZeroVatTotal: transactionItem.fromCurrencyZeroVatTotal.ToNumber(),
    fromCurrencyVatExemptedTotal: transactionItem.fromCurrencyVatExemptedTotal.ToNumber(),
    fromCurrencySubTotalForcalculateWHT: transactionItem.fromCurrencySubTotalForcalculateWHT.ToNumber(),
    toCurrencyPrice: transactionItem.toCurrencyPrice.ToNumber(),
    toCurrencyDiscount: transactionItem.toCurrencyDiscount.ToNumber(),
    toCurrencyWHTTotal: transactionItem.toCurrencyWHTTotal.ToNumber(),
    toCurrencyNetTotal: transactionItem.toCurrencyNetTotal.ToNumber(),
    toCurrencyVatTotal: transactionItem.toCurrencyVatTotal.ToNumber(),
    toCurrencyPreVatTotal: transactionItem.toCurrencyPreVatTotal.ToNumber(),
    toCurrencyZeroVatTotal: transactionItem.toCurrencyZeroVatTotal.ToNumber(),
    toCurrencyVatExemptedTotal: transactionItem.toCurrencyVatExemptedTotal.ToNumber(),
    toCurrencySubTotalForcalculateWHT: transactionItem.toCurrencySubTotalForcalculateWHT.ToNumber(),
    allocationTransactionList: GetCreateAllocationTransaction(transaction.classificationTransactionList),
  };

  return transactionItemBase;
}

export function GetCreateInvoiceInput(status: any, transaction: any) {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceDepositList = ConvertToReferenceDepositListCreate(transaction.referenceDepositList);
  transactionCreate.fromCurrencyDepositVatTotal = transaction.referenceDepositSummary.fromCurrencyDepositVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositPreVatTotal = transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositZeroVatTotal = transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositVatExemptedTotal = transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatTotal = transaction.referenceDepositSummary.toCurrencyDepositVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositPreVatTotal = transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositZeroVatTotal = transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatExemptedTotal = transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal.ToNumber();

  if (
    transaction.receivedTaxInvoice &&
    transaction.receivedTaxInvoice.value &&
    transaction.receivedTaxInvoice.value.length > 0
  ) {
    const receivedTaxInvoice = transaction.receivedTaxInvoice.value[0];
    transactionCreate.receivedTaxInvoiceList.push({
      receivedTaxInvoiceNumber: receivedTaxInvoice.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: receivedTaxInvoice.receivedTaxInvoiceDate,
      preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
      vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
      netAmount:
        transaction.transactionSummary.vat.preVatTotal.ToNumber() +
        transaction.transactionSummary.vat.vatTotal.ToNumber(),
    });
  }

  if (transaction.transactionItemList) {
    for (const transactionItem of transaction.transactionItemList) {
      const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
      transactionCreate.transactionItemList.push(transactionItemCreate);
    }
  }

  return {
    financeType: transactionCreate.financeTypeId,
    expenseType: transaction.expenseType,
    transaction: transactionCreate,
  };
}

export const GetCreatePurchaseInventoryInput = (status: any, transaction: any) => {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceDepositList = ConvertToReferenceDepositListCreate(transaction.referenceDepositList);
  transactionCreate.fromCurrencyDepositVatTotal = transaction.referenceDepositSummary.fromCurrencyDepositVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositPreVatTotal = transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositZeroVatTotal = transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositVatExemptedTotal = transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatTotal = transaction.referenceDepositSummary.toCurrencyDepositVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositPreVatTotal = transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositZeroVatTotal = transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatExemptedTotal = transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal.ToNumber();

  if (
    transaction.receivedTaxInvoice &&
    transaction.receivedTaxInvoice.value &&
    transaction.receivedTaxInvoice.value.length > 0
  ) {
    const receivedTaxInvoice = transaction.receivedTaxInvoice.value[0];
    transactionCreate.receivedTaxInvoiceList.push({
      receivedTaxInvoiceNumber: receivedTaxInvoice.receivedTaxInvoiceNumber,
      receivedTaxInvoiceDate: receivedTaxInvoice.receivedTaxInvoiceDate,
      preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
      vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
      netAmount:
        transaction.transactionSummary.vat.preVatTotal.ToNumber() +
        transaction.transactionSummary.vat.vatTotal.ToNumber(),
    });
  }

  if (transaction.transactionItemList) {
    for (const transactionItem of transaction.transactionItemList) {
      const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
      transactionCreate.transactionItemList.push(transactionItemCreate);
    }
  }

  return {
    financeType: transactionCreate.financeTypeId,
    expenseType: transaction.expenseType,
    transaction: transactionCreate,
  };
};

export function GetCreateQuotationInput(status: any, transaction: any) {
  const summary = GetTransactionSummary(transaction);
  const transactionCreate = {
    dueDate: transaction.dueDate.hidden ? null : transaction.dueDate.value,
    actionDate: null,
    id: 0,
    number: transaction.number.value,
    date: transaction.date.value,
    isVat: false,
    discount: transaction.transactionDiscount.value,
    discountType: transaction.transactionDiscount.discountType,
    remark: transaction.remark.text,
    status: 0,
    contact: {
      id: transaction.contact.id,
      contactCode: transaction.contact.contactCode,
      creditLimit: transaction.contact.creditLimit,
      creditLimitSettingType: transaction.contact.creditLimitSettingType,
    },
    financeTypeId: transaction.financeType,
    taxStatus: transaction.taxStatus.value,
    isDeleted: false,
    referenceName: transaction.reference.referenceName,
    transactionSummary: {
      subTotal:
        transaction.transactionSummary.vat.preVatTotal.ToNumber() +
        transaction.transactionSummary.vatExemptedTotal.ToNumber() +
        transaction.transactionSummary.zeroVatTotal.ToNumber(),
      netAmount: transaction.transactionSummary.netAmount.ToNumber(),
      whtTotal: summary.transactionSummary.whtTotal.ToNumber(),
      vatExemptedTotal: transaction.transactionSummary.vatExemptedTotal.ToNumber(),
      zeroVatTotal: transaction.transactionSummary.zeroVatTotal.ToNumber(),
      preVatTotal: transaction.transactionSummary.vat.preVatTotal.ToNumber(),
      vatTotal: transaction.transactionSummary.vat.vatTotal.ToNumber(),
      subTotalForCalculateWht: transaction.transactionSummary.subTotalForCalculateWht.ToNumber(),
      isAllNoneOrNotSpecifyWht: transaction.transactionSummary.isNoneOrNotSpecifyWht,
      isServiceOnly: transaction.transactionSummary.isServiceOnly,
      sameProductVatType: transaction.transactionSummary.sameProductVatType,
    },
    transactionCurrency: {
      currencyNetAmount: transaction.transactionCurrencySummary.netAmount.ToNumber(),
      currencyZeroVatTotal: transaction.transactionCurrencySummary.zeroVatTotal.ToNumber(),
      currencyPreVatTotal: transaction.transactionCurrencySummary.vat.preVatTotal.ToNumber(),
      currencyVatTotal: transaction.transactionCurrencySummary.vat.vatTotal.ToNumber(),
      currencySubTotalForCalculateWht: summary.transactionCurrencySummary.subTotalForCalculateWht.ToNumber(),
      currencyWhtTotal: summary.transactionCurrencySummary.whtTotal.ToNumber(),
      currencyExchangeRates: transaction.transactionCurrencySummary.exchangeRate.ToNumber(),
      currencyRatio: transaction.transactionCurrencySummary.ratio.ToNumber(),
      currencyVatExemptedTotal: transaction.transactionCurrencySummary.vatExemptedTotal.ToNumber(),
      fromCurrencyUid: transaction.transactionCurrencySummary.fromCurrencyUId.ToNumber(),
      toCurrencyUid: transaction.transactionCurrencySummary.toCurrencyUId.ToNumber(),
    },
    transactionItemList: [] as any[],
    fileList: transaction.fileList,
    tagList: transaction.tagList,
  };
  if (transaction.transactionItemList) {
    for (const transactionItem of transaction.transactionItemList) {
      const _transactionItem = {
        transactionId: 0,
        description: transactionItem.description.text,
        price: transactionItem.price.value.ToNumber(),
        amount: transactionItem.amount.value.ToNumber(),
        discount: transactionItem.discount.value.ToNumber(),
        vatType: transactionItem.vatTypeId.value,
        productTemplateId: transactionItem.productTemplate.id,
        productTemplateCode: transactionItem.productTemplate.code,
        discountType: transactionItem.discount.discountTypeId,
        netAmount: transactionItem.itemPreVatTotal.ToNumber(),
        accountId: transactionItem.account.id,
        accountCode: transactionItem.account.code,
        isDescriptionOnly: transactionItem.isDescriptionOnly,
        whtAmount: transactionItem.itemWht.value,
        whtAmountType: transactionItem.itemWht.whtAmountType,
        sequenceNumber: 0,
      };
      transactionCreate.transactionItemList.push(_transactionItem);
    }
  }
  if (status != null) {
    transactionCreate.status = status;
  }
  return { financeType: transactionCreate.financeTypeId, transaction: transactionCreate };
}

export function GetCreateReceiptInput(status: any, transaction: any) {
  const transactionCreate = GetCreateTransactionBase(transaction);
  transactionCreate.dueDate = transaction.dueDate.value;
  transactionCreate.status = status != null ? status : 0;
  transactionCreate.referenceDepositList = ConvertToReferenceDepositListCreate(transaction.referenceDepositList);
  transactionCreate.fromCurrencyDepositVatTotal = transaction.referenceDepositSummary.fromCurrencyDepositVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositPreVatTotal = transaction.referenceDepositSummary.fromCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositZeroVatTotal = transaction.referenceDepositSummary.fromCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.fromCurrencyDepositVatExemptedTotal = transaction.referenceDepositSummary.fromCurrencyDepositVatExemptedTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatTotal = transaction.referenceDepositSummary.toCurrencyDepositVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositPreVatTotal = transaction.referenceDepositSummary.toCurrencyDepositPreVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositZeroVatTotal = transaction.referenceDepositSummary.toCurrencyDepositZeroVatTotal.ToNumber();
  transactionCreate.toCurrencyDepositVatExemptedTotal = transaction.referenceDepositSummary.toCurrencyDepositVatExemptedTotal.ToNumber();

  if (transaction.transactionItemList) {
    for (const transactionItem of transaction.transactionItemList) {
      const transactionItemCreate = GetCreateTransactionItemBase(transaction, transactionItem);
      transactionCreate.transactionItemList.push(transactionItemCreate);
    }
  }

  return { financeType: transactionCreate.financeTypeId, transaction: transactionCreate };
}
